import type { WorkspaceNotificationGroup } from '../../types'
import { WORKSPACE_NOTIFICATION_CHANNEL } from '../../types'

export const WORKSPACE_NOTIFICATIONS_MOCK: WorkspaceNotificationGroup[] = [
  {
    id: 'GRAFTS',
    items: [
      {
        id: 'CREATED',
        groupId: 'GRAFTS',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'FAILED',
        groupId: 'GRAFTS',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'UPDATED',
        groupId: 'GRAFTS',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
    ],
  },
  {
    id: 'GATEWAYS_SERVICES',
    items: [
      {
        id: 'CONFIG_CHANGED',
        groupId: 'GATEWAYS_SERVICES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'CONNECTED',
        groupId: 'GATEWAYS_SERVICES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'LATENCY',
        groupId: 'GATEWAYS_SERVICES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
    ],
  },
  {
    id: 'PACKAGES',
    items: [
      {
        id: 'INSTALLED',
        groupId: 'PACKAGES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'UPDATE',
        groupId: 'PACKAGES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'INSECURE',
        groupId: 'PACKAGES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
    ],
  },
  {
    id: 'DIGESTS',
    items: [
      {
        id: 'DAILY',
        groupId: 'DIGESTS',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'WEEKLY',
        groupId: 'DIGESTS',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
    ],
  },
  {
    id: 'VULNERABILITIES',
    items: [
      {
        id: 'WARNINGS',
        groupId: 'VULNERABILITIES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'CRITICAL',
        groupId: 'VULNERABILITIES',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
    ],
  },
  {
    id: 'SYSTEM_ADMIN',
    items: [
      {
        id: 'PERMISSIONS',
        groupId: 'SYSTEM_ADMIN',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
      {
        id: 'BILLING',
        groupId: 'SYSTEM_ADMIN',
        channels: {
          [WORKSPACE_NOTIFICATION_CHANNEL.EMAIL]: true,
          [WORKSPACE_NOTIFICATION_CHANNEL.IN_APP]: true,
        },
      },
    ],
  },
]
